import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  deviceType: "desktop", // "desktop" | "tablet" | "mobile"
  isMobile: false,       // true for both tablet and mobile
  isTablet: false,
  serverMode: "",
};

const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setDeviceType(state, action) {
      const type = action.payload.deviceType;
      state.deviceType = type;
      state.isMobile = type === "mobile" || type === "tablet";
      state.isTablet = type === "tablet";
    },
    setServerMode(state, action) {
      state.serverMode = action.payload;
    },
    setResetDeviceType(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { setDeviceType, setServerMode, setResetDeviceType } =
  deviceSlice.actions;
export default deviceSlice.reducer;
